<template>
	<div style="display: grid;">
		<div class="level">
			<div class="level-left">
				<div class="level-item">
					<h1 class="title">Partidos</h1>
				</div>
			</div>
			<div class="level-item">
				<Pagination v-if="partidos" :current_page="partidos.current_page" :last_page="partidos.last_page" :prev_page_url="partidos.prev_page_url"  :next_page_url="partidos.next_page_url" v-on:nextPage="nextPage" v-on:previousPage="previousPage" v-on:gotoPage="gotoPage"/>
				
			</div>
			<div class="level-right">
				<div class="level-item">
					<router-link class="button is-primary" :to="{name: 'partido-new'}">+ Nuevo Partido</router-link>
				</div>
			</div>
		</div>
		<div class="table-container">
			<table class="table is-bordered is-narrow is-fullwidth">
				<thead>
					<tr>
						<th>Id</th>
						<th>Activo</th>
						<th>Local</th>
						<th>Visitante</th>
						<th>Inicia</th>
						<th>Torneo</th>
						<th>Estado</th>
						<th>Editar</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(partido, key) in partidos.data" :key="key">
						<td>{{ partido.id }}</td>
						<td>{{ partido.active ? 'Si':'No' }}</td>
						<td>{{ partido.equipo_local.nombre }}</td>
						<td>{{ partido.equipo_visitante.nombre }}</td>
						<td>{{ partido.inicia }}</td>
						<td>{{ partido.torneo.nombre }}</td>
						<td>{{ estado(partido.estado) }}</td>
						<td><router-link class="button is-small" :to="{ name: 'partido', params: { id: partido.id } }">Editar</router-link></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import Pagination from '@/components/Pagination'
	import { mapState } from "vuex";

	export default {
		components: { Pagination },
		name: 'Partidos',
		data() {
			return {
				
			};
		},
		created(){
			//if (!this.partidos.data) {
				this.$store.dispatch('partidos/fetchPartidos');
			//}
		},
		mounted(){
		},
		methods: {
			nextPage(){
				this.$store.dispatch('partidos/fetchPartidos', this.partidos.next_page_url)
			},
			previousPage(){
				this.$store.dispatch('partidos/fetchPartidos', this.partidos.prev_page_url)
			},
			gotoPage(event){
				let page = event.currentTarget.getAttribute('data-page')
				this.$store.dispatch('partidos/fetchPartidos', this.partidos.path + '?page=' + page)	
			},
			estado(estado){
				let resp = ''
				switch(estado){
					case 0:
						resp = 'normal'
					break;
					case 1:
						resp = 'en juego'
					break;
					case 2:
						resp = 'terminado'
					break;
				}
				return resp
			}
		},
		computed: {
			...mapState('partidos',['partidos'])	
		}
	};
</script>

<style lang="css" scoped>
</style>
